import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './TextLinkImage.styles'
import { Grid, Link } from 'components/atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { useLocalisation } from 'hooks/useLocalisation'

/**
 * functional container for all detail views
 * @returns {*}
 * @constructor
 */
const TextLinkImage = ({
  headline,
  copy,
  moreLink,
  image,
  showCookieHeader,
}) => {
  const textContext = useContext(TextContext)
  const { clientName } = useLocalisation()

  /* assets used here are so small that they get converted to base64 so the staticAssetPath should not be appended */
  // const filterStaticAssetPath = imagePath => `${ !imagePath.includes('data:image/') ? staticAssetPath : '' }${imagePath}`
  // TODO: check if PUBLIC_URL is add ached to base64 image
  const filterStaticAssetPath = (imagePath) =>
    `${ !imagePath.includes('data:image/') ? '' : '' }${ imagePath }`

  return (
    <Styled.TextLinkImageComponent>
      <Grid
        container
        style={{
          display: !image && 'block',
        }}>
        {showCookieHeader && (
          <Grid item xs={ 12 }>
            <div className='cookieHeader'>
              <span>
                {' '}
                {textContext['textLinkImage.cookie.info']}{' '}
                <strong>{clientName}</strong>
              </span>
            </div>
          </Grid>
        )}
        <Grid item xs={ 12 } sm={ image ? 9 : 12 } print={ image ? 9 : 12 }>
          {headline && (
            <p>
              <b>{headline}</b>
            </p>
          )}
          {copy && <p>{copy}</p>}
          {moreLink && (
            <Link
              href={ moreLink.url }
              isNativeLink={ true }
              target={ moreLink.target ? moreLink.target : null }
              className={ 'link more-link' }
              rel={ moreLink.target === '_blank' ? 'noopener noreferrer' : null }>
              {textContext['general.exploreMore']}
            </Link>
          )}
        </Grid>
        {image && (
          <Grid item xs={ 12 } sm={ 3 } print={ 3 }>
            <img
              className={ 'image' }
              src={ filterStaticAssetPath(image.url) }
              alt={ image.alt }
            />
          </Grid>
        )}
      </Grid>
    </Styled.TextLinkImageComponent>
  )
}

TextLinkImage.defaultProps = {
  showCookieHeader: false,
}

TextLinkImage.propTypes = {
  headline: PropTypes.string,
  copy: PropTypes.string,
  moreLink: PropTypes.shape({
    url: PropTypes.string,
    target: PropTypes.string,
  }),
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  showCookieHeader: PropTypes.bool,
}

export default TextLinkImage
